import { Box, Flex, useColorModeValue } from "@chakra-ui/react";
import { DependencyPill } from "features/Trigger/TemplateTrigger/Components/TaskDependencyPill";
import { Text14 } from "components/Text";
import { Trigger, TRIGGER_TYPE_DEPENDENCY } from "features/Trigger/TemplateTrigger/models";
import AttributeButton from "components/Button/AttributeButton";
import { TriggerSchema } from "features/Trigger/TemplateTrigger/Form/schema";

interface TriggerButtonProps {
  trigger: TriggerSchema | Trigger;
  descriptor: string;
  buttonVariant: string;
  disabled: boolean;
  onClick?: React.MouseEventHandler<HTMLButtonElement | HTMLDivElement>;
}

export default function TriggerButton({
  trigger, descriptor, buttonVariant, onClick, disabled,
}: TriggerButtonProps) {
  const color = useColorModeValue("valueBlack.DEFAULT", "var(--chakra-colors-whiteAlpha-900)");
  const bgHover = useColorModeValue("editableBackgroundGrey.light", "cdsGrey.700");
  return trigger && trigger.type === TRIGGER_TYPE_DEPENDENCY && trigger?.data?.dependencyId ? (
    <Flex gap="2" cursor="pointer" align="center" onClick={onClick}>
      <Text14 color="cdsGrey.800">After:</Text14>
      <DependencyPill pageType="TaskTemplate" dependencyId={trigger.data.dependencyId} />
    </Flex>
  ) : (
    <Box>
      <AttributeButton
        variant={buttonVariant}
        disabled={disabled}
        onClick={onClick}
        height="32px !important"
        paddingTop="0 !important"
        paddingLeft="2 !important"
        bg="bg.control"
        color={color}
        justifyContent="flex-start"
        fontWeight="normal"
        minW="unset"
        w="auto"
        paddingX="8px !important"
        _hover={{
          ...(disabled ? {} : { bg: bgHover }),
        }}
        cursor={disabled ? "default" : "pointer"}
      >
        {descriptor}
      </AttributeButton>
    </Box>
  );
}
